import script from "./InputRangeSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRangeSettings.vue?vue&type=script&setup=true&lang=js"

import "./InputRangeSettings.vue?vue&type=style&index=0&id=3eb323bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb323bc"]])

export default __exports__